import { useQuery } from "@tanstack/react-query";
import CustomFieldsApi from "@/api/custom-fields";
import { CUSTOM_FIELD_CATEGORIES } from "@/pages/Settings/CustomFieldSettings/utils/customFieldConstants";

interface CustomField {
  field_id: number;
  field_name: string;
  editor_type: "textBox" | "dropDown" | "dateBox" | "tagBox";
  description?: string;
  options: string[] | null;
  is_required?: number;
  enabled: number;
  type_ids: number[] | null;
  sort_value: number;
}

export const useCustomFields = () => {
  return useQuery({
    queryKey: ["inquiries", "customFields", "list"],
    queryFn: () =>
      CustomFieldsApi.getCustomFields({
        category: CUSTOM_FIELD_CATEGORIES.INQUIRY,
      }),
    select: (data) => data?.filter((c: CustomField) => c.enabled === 1),
  });
};

export type { CustomField };
